import React, { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";
import { useLang } from "../i18n";

export default function SignaturePad({ onChange, testid = "signature-canvas" }) {
  const { t } = useLang();
  const ref = useRef(null);
  const drawing = useRef(false);
  const [signed, setSigned] = useState(false);

  useEffect(() => {
    const canvas = ref.current;
    canvas.width = canvas.offsetWidth * 2;
    canvas.height = 320;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#16335F";
  }, []);

  const pos = (e) => {
    const canvas = ref.current;
    const rect = canvas.getBoundingClientRect();
    const cx = e.clientX ?? e.touches?.[0]?.clientX;
    const cy = e.clientY ?? e.touches?.[0]?.clientY;
    return { x: (cx - rect.left) * (canvas.width / rect.width), y: (cy - rect.top) * (canvas.height / rect.height) };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setSigned(true);
    onChange(ref.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = ref.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setSigned(false);
    onChange(null);
  };

  return (
    <div>
      <div className="rounded-lg border-2 border-dashed border-slate-300 bg-white overflow-hidden">
        <canvas
          ref={ref}
          data-testid={testid}
          className="w-full h-40 touch-none cursor-crosshair"
          onPointerDown={start}
          onPointerMove={move}
          onPointerUp={end}
          onPointerLeave={end}
        />
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-slate-500">{t("forms.sign_hint")}</span>
        <button
          type="button"
          onClick={clear}
          data-testid="signature-clear-button"
          className="flex items-center gap-1 text-xs font-semibold text-slate-600 hover:text-red-600"
        >
          <Eraser className="w-3.5 h-3.5" /> {t("forms.clear")}
        </button>
      </div>
    </div>
  );
}
